module.exports = __webpack_public_path__ + "img/almacen.3f834865.jpeg";